import React from 'react';
import { SIGNAGE_FEATURE, SIGNAGE_ITEMS } from '../homeData';

const HomeSignage = () => (
  <div className="home-signage">
    <article className="home-signage__hero">
      <img src={SIGNAGE_FEATURE.image} alt={SIGNAGE_FEATURE.label} />
      <div className="home-signage__hero-overlay" />
      <div className="home-signage__hero-content">
        <span className="home-signage__tag">{SIGNAGE_FEATURE.label}</span>
        <h3>{SIGNAGE_FEATURE.title}</h3>
        <p>Vientiane Traffic</p>
      </div>
    </article>

    <div className="home-signage__grid">
      {SIGNAGE_ITEMS.map((item) => (
        <article key={item.label} className="home-signage__card">
          <div className="home-signage__card-media">
            <img src={item.image} alt={item.label} />
            <span className="home-signage__card-tag">{item.label}</span>
          </div>
          <p>{item.title}</p>
        </article>
      ))}
    </div>
  </div>
);

export default HomeSignage;
